import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { mdi } from 'vuetify/iconsets/mdi'
import { md } from 'vuetify/iconsets/md'

// Aliases Vuetify components reference internally (v-radio, v-checkbox, v-data-table sort arrows, v-select dropdown, etc.)
// Mapped to Material Icons ligature names since defaultSet is 'md'.
const mdAliases = {
	complete: 'check',
	cancel: 'cancel',
	close: 'close',
	delete: 'cancel',
	clear: 'cancel',
	success: 'check_circle',
	info: 'info',
	warning: 'priority_high',
	error: 'warning',
	prev: 'chevron_left',
	next: 'chevron_right',
	checkboxOn: 'check_box',
	checkboxOff: 'check_box_outline_blank',
	checkboxIndeterminate: 'indeterminate_check_box',
	delimiter: 'fiber_manual_record',
	sortAsc: 'arrow_upward',
	sortDesc: 'arrow_downward',
	expand: 'keyboard_arrow_down',
	menu: 'menu',
	subgroup: 'arrow_drop_down',
	dropdown: 'arrow_drop_down',
	radioOn: 'radio_button_checked',
	radioOff: 'radio_button_unchecked',
	edit: 'edit',
	ratingEmpty: 'star_border',
	ratingFull: 'star',
	ratingHalf: 'star_half',
	loading: 'cached',
	first: 'first_page',
	last: 'last_page',
	unfold: 'unfold_more',
	file: 'attach_file',
	plus: 'add',
	minus: 'remove',
	calendar: 'event',
	treeviewCollapse: 'arrow_drop_down',
	treeviewExpand: 'arrow_right',
	eyeDropper: 'colorize',
	upload: 'cloud_upload',
	colorPickerSwatches: 'palette',
	colorPickerCanvas: 'gradient',
}

export default createVuetify({
	components,
	directives,
	icons: {
		defaultSet: 'md',
		aliases: mdAliases,
		sets: { md, mdi },
	},
	defaults: {
		// Vuetify 3's v-card-actions provides defaults that force child
		// v-btns to { variant: 'text', slim: true }. That turns every
		// dialog action button into a transparent text link — the v1/v2
		// "depressed" pattern (colored, no shadow) stops working until
		// each button is rewritten with variant="flat" explicitly. Reset
		// the inherited defaults here so legacy `<v-btn color="..." depressed>`
		// renders as a flat colored button across the app.
		VCardActions: {
			VBtn: {
				variant: 'flat',
				slim: false,
			}
		},
		// Vuetify 3 defaults v-btn to variant="elevated" which paints a
		// white background + drop shadow even on icon-only buttons. Keep
		// the default elevated for now and let icon buttons be flattened
		// by the global SCSS rule in _vuetify.scss. (Don't change the
		// global VBtn default — it would affect every non-action button
		// in the app.)

		// Vuetify 3's v-date-picker renders a tall "SELECT DATE / <selected
		// date>" header by default that V2 never showed (V2's `no-title`
		// prop was renamed to `hide-header`). Hide it globally so every
		// picker reads as a compact month/grid like staging.
		VDatePicker: {
			hideHeader: true,
		},
	},
	theme: {
		defaultTheme: 'light',
		themes: {
			light: {
				colors: {
					primary: '#0D47A1',
					secondary: '#FF9800',
					accent: '#0D47A1',
					// Vuetify 3's default `error` is a dark crimson (#B00020).
					// Use the standard Material red from the palette so error
					// alerts read as a normal red, like the v2 build did.
					error: '#F44336',
					// `on-*` colors tell Vuetify which contrast color to use
					// for text/icons rendered ON TOP of a given color. Without
					// these, Vuetify defaults `on-primary` to near-black, so
					// every `<v-btn color="primary">` rendered with invisible
					// dark text on the dark blue fill. White text on all the
					// colored backgrounds.
					'on-primary': '#FFFFFF',
					'on-secondary': '#FFFFFF',
					'on-accent': '#FFFFFF',
					'on-error': '#FFFFFF',
					'on-success': '#FFFFFF',
					'on-warning': '#FFFFFF',
					'on-info': '#FFFFFF',
				}
			}
		}
	}
})
